{
  "CAMPAIGN": {
    "LIVE_CHAT": {
      "HEADER_TITLE": "Live chat campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "CARD": {
        "STATUS": {
          "ENABLED": "Abilitato",
          "DISABLED": "Disabilitato"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_BY": "Inviato da",
          "BOT": "Bot",
          "FROM": "da",
          "URL": "URL:"
        }
      },
      "EMPTY_STATE": {
        "TITLE": "No live chat campaigns are available",
        "SUBTITLE": "Connect with your customers using proactive messages.  Click 'Create campaign' to get started."
      },
      "CREATE": {
        "TITLE": "Create a live chat campaign",
        "CANCEL_BUTTON_TEXT": "annulla",
        "CREATE_BUTTON_TEXT": "Crea",
        "FORM": {
          "TITLE": {
            "LABEL": "Titolo",
            "PLACEHOLDER": "Inserisci il titolo della campagna",
            "ERROR": "Il titolo è obbligatorio"
          },
          "MESSAGE": {
            "LABEL": "Messaggio",
            "PLACEHOLDER": "Inserisci il messaggio della campagna",
            "ERROR": "Il messaggio è obbligatorio"
          },
          "INBOX": {
            "LABEL": "Seleziona casella",
            "PLACEHOLDER": "Seleziona casella",
            "ERROR": "La casella è obbligatoria"
          },
          "SENT_BY": {
            "LABEL": "Inviato da",
            "PLACEHOLDER": "Please select sender",
            "ERROR": "Il mittente è obbligatorio"
          },
          "END_POINT": {
            "LABEL": "URL",
            "PLACEHOLDER": "Inserisci un URL valido",
            "ERROR": "Inserisci un URL valido",
            "URL_IS_REGEXP": "Il valore è un'espressione regolare"
          },
          "TIME_ON_PAGE": {
            "LABEL": "Tempo sulla pagina (Secondi)",
            "PLACEHOLDER": "Inserisci l'ora",
            "ERROR": "Il tempo sulla pagina è richiesto"
          },
          "OTHER_PREFERENCES": {
            "TITLE": "Other preferences",
            "ENABLED": "Abilita campagna",
            "TRIGGER_ONLY_BUSINESS_HOURS": "Attiva solo durante l'orario lavorativo"
          },
          "BUTTONS": {
            "CREATE": "Crea",
            "CANCEL": "annulla"
          },
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign created successfully",
            "ERROR_MESSAGE": "Si è verificato un errore, riprova."
          }
        }
      },
      "EDIT": {
        "TITLE": "Edit live chat campaign",
        "FORM": {
          "API": {
            "SUCCESS_MESSAGE": "Live chat campaign updated successfully",
            "ERROR_MESSAGE": "Si è verificato un errore, riprova."
          }
        }
      }
    },
    "SMS": {
      "HEADER_TITLE": "SMS campaigns",
      "NEW_CAMPAIGN": "Create campaign",
      "EMPTY_STATE": {
        "TITLE": "No SMS campaigns are available",
        "SUBTITLE": "Launch an SMS campaign to reach your customers directly. Send offers or make announcements with ease. Click 'Create campaign' to get started."
      },
      "CARD": {
        "STATUS": {
          "COMPLETED": "Completato",
          "SCHEDULED": "Scheduled"
        },
        "CAMPAIGN_DETAILS": {
          "SENT_FROM": "Sent from",
          "ON": "on"
        }
      },
      "CREATE": {
        "TITLE": "Create SMS campaign",
        "CANCEL_BUTTON_TEXT": "annulla",
        "CREATE_BUTTON_TEXT": "Crea",
        "FORM": {
          "TITLE": {
            "LABEL": "Titolo",
            "PLACEHOLDER": "Inserisci il titolo della campagna",
            "ERROR": "Il titolo è obbligatorio"
          },
          "MESSAGE": {
            "LABEL": "Messaggio",
            "PLACEHOLDER": "Inserisci il messaggio della campagna",
            "ERROR": "Il messaggio è obbligatorio"
          },
          "INBOX": {
            "LABEL": "Seleziona casella",
            "PLACEHOLDER": "Seleziona casella",
            "ERROR": "La casella è obbligatoria"
          },
          "AUDIENCE": {
            "LABEL": "Pubblico",
            "PLACEHOLDER": "Seleziona le etichette dei clienti",
            "ERROR": "Il pubblico è obbligatorio"
          },
          "SCHEDULED_AT": {
            "LABEL": "Orario previsto",
            "PLACEHOLDER": "Seleziona l'orario",
            "ERROR": "È richiesto un orario programmato"
          },
          "BUTTONS": {
            "CREATE": "Crea",
            "CANCEL": "annulla"
          },
          "API": {
            "SUCCESS_MESSAGE": "SMS campaign created successfully",
            "ERROR_MESSAGE": "Si è verificato un errore, riprova."
          }
        }
      }
    },
    "CONFIRM_DELETE": {
      "TITLE": "Sei sicuro di voler eliminare?",
      "DESCRIPTION": "The delete action is permanent and cannot be reversed.",
      "CONFIRM": "Elimina",
      "API": {
        "SUCCESS_MESSAGE": "Campagna eliminata con successo",
        "ERROR_MESSAGE": "Si è verificato un errore, riprova."
      }
    }
  }
}
